<template>
    <div class="card mb-0" v-if="registration">

        <el-table class="table-responsive table-flush"
                :show-header="false"
                :data="preparedCompetencies">

            <el-table-column>
                <template v-slot="{row}">
                    <div :class="{'global':row.isGlobal}">
                        <h4 class="mb-0">
                            {{ competencyName(row) }}
                        </h4>
                        <div v-if="row.domain">
                            <badge rounded :type="row.domain.color" class="mt-1">
                                {{ competencyDomainName(row) }}
                            </badge>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column align="center" class-name="competencies" width="160">
                <template v-slot="{row}">
                    <div :class="{'global':row.isGlobal}">
                        <ratings :data="competencyRatings(row)" :position="position"
                            v-if="competencyRatings(row)"
                        ></ratings>
                    </div>
                </template>
            </el-table-column>
            
        </el-table>
    </div>
</template>

<script>
    import Ratings from '../charts/CompetencyRatings';

    export default {

        components: {
            Ratings,
        },

        props: {

            registration: {
                type: Object,
            },

            competencies: {
                type: Array,
            },

            ratings: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },

            position: {
                type: String,
            },
        },
        
        computed: {

            preparedCompetencies() {
                let all = [...this.competencies]
                all.unshift({
                    id: 0,
                    isGlobal: true,
                    name_en: "Global",
                    name_fr: "Global",
                })
                return all
            }
        },

        methods: {

            competencyName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency[nameProp]
            },

            competencyDomainName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency.domain[nameProp]
            },

            competencyRatings(competency) {
                return this.ratings[competency.id] === undefined ? [] : this.ratings[competency.id]
            },
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding: 1.5rem 0 1.5rem 1.5rem;
        font-size: 0.8rem;
    }
    .card >>> td.competencies {
        padding: 0.3rem 0 0.3rem 0;
    }
    .card >>> td:has(.global) {
        background-color: #f6f9fc !important;
    }

</style>
